// @refresh reload
import { mount, StartClient } from "@solidjs/start/client";

if (import.meta.env.DEV) {
  window.addEventListener("error", (event) => {
    console.error(
      "[client-error]",
      event.message,
      "@",
      event.filename,
      event.lineno,
      event.colno,
      event.error ?? null,
      event.error?.stack
    );
  });
  window.addEventListener("unhandledrejection", (event) => {
    console.error("[client-unhandledrejection]", event.reason, event.reason?.stack ?? null);
  });
}

// Register service worker (guarded, no-op if unavailable)
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  const shouldRegister =
    // Default on; allow disabling via env flag
    import.meta.env.VITE_ENABLE_SERVICE_WORKER !== "false";

  if (shouldRegister) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .catch((err) => console.warn("[sw] registration failed", err));
    });
  }
}

mount(() => <StartClient />, document.getElementById("app")!);
